module.exports = __webpack_public_path__ + "img/20befe3.png";